import classNames from "classnames";
import React from "react";

interface IProps {
  title: string;
  className?: string;
  children: React.ReactNode;
  index?: number;
  currentStoreMenuIdx?: number;
  selectStoreMenuHandler?: (index: number) => void;
  isMobileNavMenu?: boolean;
}

function NavMenu({
  title,
  className,
  children,
  index,
  currentStoreMenuIdx,
  selectStoreMenuHandler,
  isMobileNavMenu,
}: IProps) {
  return (
    <div className={classNames(className)}>
      {isMobileNavMenu ? (
        <div className={classNames(title === "Line" && "h-px w-full bg-tuneGrey-300")}>
          <span
            className={classNames(
              "inline-block",
              title === "Featured" ? "text-sm uppercase text-tertiary" : "text-xl capitalize",
              title === "Line" && "pointer-events-none h-10 cursor-none opacity-0",
            )}
            onClick={() => {
              if (index !== undefined && selectStoreMenuHandler) {
                selectStoreMenuHandler(currentStoreMenuIdx === index ? -1 : index);
              }
            }}
            role="presentation"
          >
            {title}
          </span>
          {title === "Featured" ? (
            <nav>
              <ul className="mt-5 flex flex-col gap-5 text-xl">{children}</ul>
            </nav>
          ) : (
            <>
              {currentStoreMenuIdx === index && (
                <nav>
                  <ul className="mt-5 flex flex-col gap-5 pl-5">{children}</ul>
                </nav>
              )}
            </>
          )}
        </div>
      ) : (
        <div className={`${title === "Line" && "size-full bg-line bg-contain bg-center bg-no-repeat"}`}>
          <span
            className={classNames(
              "inline-block text-sm font-regular uppercase",
              title === "Sale" ? "bg-highlight text-quaternary" : "text-tertiary",
              title === "Line" && "opacity-0",
            )}
          >
            {title}
          </span>
          <nav>
            <ul className="mt-5 flex flex-col gap-2.5">{children}</ul>
          </nav>
        </div>
      )}
    </div>
  );
}

export default NavMenu;
